import {memo, useEffect, useRef} from 'react'
import type {Iri} from '../../../../@types/Api'
import {useSpotHelperGetCurrent} from '../../../../hooks/entity/useSpot'
import {useVisitCreate} from '../../../../hooks/entity/useVisit'
import {useEffectEvent} from '../../../../hooks/useEffectEvent'
import {useErrorHandler} from '../../../../hooks/useErrorHandler'
import {useLogged} from '../../../../states/auth'
import {notFoundIdentifier, useCurrentSpotIri} from '../../../../states/currentSpot'

export const VisitListener = memo(() => {
  const logged = useLogged()
  const spotIri = useCurrentSpotIri()
  const {spot} = useSpotHelperGetCurrent()
  const visitCreate = useVisitCreate(false)
  const lastVisitedIri = useRef<Iri | undefined>(undefined)
  const errorHandler = useErrorHandler()

  const registerVisit = useEffectEvent(async () => {
    if (!spotIri) {
      return
    }

    if (lastVisitedIri.current === spotIri) {
      return
    }
    lastVisitedIri.current = spotIri
    try {
      await visitCreate({spot: spotIri, stared: true})
    } catch (err: any) {
      errorHandler(err)
    }
  })

  useEffect(() => {
    if (!spotIri || !spot || spot.demo || !logged || spotIri === notFoundIdentifier.iri) {
      return
    }

    registerVisit()
  }, [logged, registerVisit, spot, spotIri])

  return null
})
